
/* eslint-disable */
import React from 'react'
import { connect } from 'react-redux'
import dd from 'dingtalk-jsapi'
import { Button, Result } from 'antd'
import { SmileOutlined } from '@ant-design/icons'
class DingT extends React.Component {
  handleClick = () => {
    const { location: { origin } } = window
    dd.biz.util.openLink({
      url: origin,//要打开链接的地址
      onSuccess: (result) => {
      },
      onFail: (err) => {
      }
    })
  }
  render () {
    return (
      <div className='i2-container'>
        <Result
          icon={<SmileOutlined />}
          title="登陆成功，请在浏览器查看使用!"
          extra={<Button type="primary" onClick={this.handleClick}>Go</Button>}
        />

      </div>
    )
  }
}

export default DingT
